import { Box, Button, Typography } from "@mui/material";
// import useItemList from "../hooks/useItemList";
import { useCallback, MouseEvent } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AppInput from "components/AppInput";
import useItem from "../hooks/useItem";

/**
 * The ItemDetail page
 */
export default function ItemDetail() {
  const location = useLocation();
  // location.state.idと書くとundefinedになる。
  const { id } = location?.state || {};
  const [{ item }] = useItem(id);
  const navigate = useNavigate();
  const onClickBackLink = useCallback(
    (e: MouseEvent) => {
      e.preventDefault();
      navigate("/items");
    },
    [navigate],
  );

  return (
    <div>
      <h2>
        <Typography fontSize={22}>詳細</Typography>
      </h2>
      <div>
        <form>
          <Box alignItems="center" display="flex" flexDirection="column">
            <AppInput labelName="id" type="number" value={item?.id} />
            <AppInput labelName="janコード" type="number" value={item?.jan} />
            <AppInput labelName="ブランド" type="text" value={item?.brand} />
            <AppInput labelName="メーカー" type="text" value={item?.maker} />
            <Button type="submit">登録</Button>
          </Box>
        </form>
      </div>
      <a href="/items" onClick={onClickBackLink}>
        一覧に戻る
      </a>
    </div>
  );
}
